import React from 'react';
import { content, SupportedLocale } from '../lib/content';

type ProcessProps = {
  locale?: SupportedLocale;
};

export const Process: React.FC<ProcessProps> = ({ locale = 'pl' }) => {
  const t = content[locale].process;

  return (
    <section id={t.id} className="process reveal">
      <div className="container">
        <div className="section-heading">
          <h2>{t.title}</h2>
        </div>
        <div className="process-steps">
          {t.steps.map((step, index) => (
            <div className="process-step" key={step.title}>
              <div className="step-index">
                <span>{index + 1}</span>
              </div>
              <div className="step-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
